import { ResponseState } from "./ResponseState";
import { ActionType } from "./ActionType";
import { BaseStore } from "./BaseStore";
import { Dispatcher } from "./Dispatcher";

export interface IBaseApiAction {
    actionType: ActionType;
}

export interface IBaseApiStoreState {
    responseState?: ResponseState;
}

export abstract class BaseApiStore<
    TStoreState extends IBaseApiStoreState,
    TAction extends IBaseApiAction
> extends BaseStore<TStoreState> {
    constructor(dispatcher: Dispatcher<TAction>) {
        super();

        this.subscribeToDispatcher(dispatcher, (action) => this.onDispatch(action));
    }

    public isLoading(): boolean {
        return this.getState().responseState === ResponseState.Requested;
    }

    public isEmpty(): boolean {
        return this.getState().responseState === ResponseState.Empty;
    }

    protected abstract onDispatch(action: IBaseApiAction): void;
}
